/* Chiara Wonder · The Wonder Journal · progressive enhancement only (content and links work without it).
   1. TOC: marks the section being read (aria-current) in the desktop index. 2. "Copia link" button. */
(function () {
  'use strict';
  var toc = document.querySelector('[data-j-toc]');
  if (toc && 'IntersectionObserver' in window) {
    var links = {}, heads = [];
    toc.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var h = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (h) { links[h.id] = a; heads.push(h); }
    });
    var set = function (id) {
      Object.keys(links).forEach(function (k) {
        if (k === id) links[k].setAttribute('aria-current', 'true'); else links[k].removeAttribute('aria-current');
      });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) set(e.target.id); });
    }, { rootMargin: '-15% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-j-copy]');
    if (!b) return;
    var url = b.getAttribute('data-j-copy') || location.href, label = b.textContent;
    var done = function () {
      b.setAttribute('data-copied', '');
      b.textContent = 'Link copiato';
      if (window.CW && typeof window.CW.announce === 'function') window.CW.announce('Link copiato');
      setTimeout(function () { b.removeAttribute('data-copied'); b.textContent = label; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copia il link', url); });
    } else {
      window.prompt('Copia il link', url);
    }
  });
})();
